import React, { useEffect, useState } from "react";
import { Descriptions } from "antd";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { fileDetailsStore } from "../FileDetailsStore";
import { Loader } from "Components/General/Loader";
import { Button } from "Components/General/Button";
import { notificationError } from "utils/libHelpers/AntdNotification";

export const Notarization = observer<React.FC>(() => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  const [isVisible, setVisible] = useState<boolean>(false);
  const [url, setUrl] = useState<string>();
  const fetch = async () => {
    try {
      await fileDetailsStore.fetchNotarization();
      const url = getUrl();
      setUrl(url);
    } catch (error) {
      notificationError(t("Error"), t("Sorry something went wrong.", { ns: I18N_NS.GENERAL }));
    }
  };
  const verify = async () => {
    if (isVisible) {
      setVisible(false);
    }
    setVisible(true);
  };
  const getUrl = () => {
    const { verifyUrl, transactionId, sha256 } = fileDetailsStore.notarizations;
    return `${verifyUrl}&fileHash=${sha256}&transaktion=${transactionId}&showdetails=on`;
  };
  useEffect(() => {
    (async () => {
      await fetch();
    })();
  }, []);

  if (!fileDetailsStore.notarizations) {
    return <Loader />;
  }

  return (
    <>
      <Descriptions
        bordered
        className="mb-md"
        extra={
          <Button onClick={verify} type="primary">
            {t("Verify")}
          </Button>
        }
        column={1}
      >
        <Descriptions.Item label={t("Transaction ID")}>
          {fileDetailsStore.notarizations?.transactionId}
        </Descriptions.Item>
        <Descriptions.Item label={t("Notarization timestamp")}>
          {fileDetailsStore.notarizations?.timestamp}
        </Descriptions.Item>
        <Descriptions.Item label={t("Service information")}>
          {fileDetailsStore.notarizations?.service}
        </Descriptions.Item>
      </Descriptions>
      {isVisible && <iframe style={{ width: "100%", height: 400 }} src={url} title="verify" />}
    </>
  );
});
